import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const UnreadCount = styled.div`
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  border-radius: 56px;
  border: 1px solid ${COLORS.white};
  background: ${COLORS.systemSky200};
  color: ${COLORS.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px;
  position: absolute;
  bottom: 0;
  right: -8px;
  min-width: 18px;
  z-index: 1;
`;
